import React from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    COLOR
} from '../../../business-const/Color/Color'

import {
    arrayNULL,
    arraySoma,
    arrayMaiorValor,
    arrayMenorValor,
} from '../../../business-components/Array/Array'

import {
    roundEscala
} from '../../../business-components/round/round'

import {
    GridContainer,
    GridItem11,
    GridItem12,
 } from '../../../business-components/Grid/Grid'

import {
    ChartPadrao
} from '../../../business-components/Chart/Chart'

import {
    relatorioModoApresentacao,
} from '../estudo-form/EstudoService'

import {
    CardGridEstudoPadrao,
} from '../estudo-form/EstudoComp'



const BalancoReceitaXDespesaAnualChart = ( { variaveisGlobais, values, setFieldValue, estudo, vars, report, moreLessList, aiFT } ) => {

    const BalancoReceitaXDespesaAnual = ( /*props*/ ) => {

        const series = []

        const paletaCoresEspecifica = []

        let yaxisMin = 0

        let arrayMax
        let yaxisMax = 0



        series.push(
            {
                name: LABEL.receitaAnual,
                type: 'area',
                data: estudo.current.graficoReceitaAnualTotal,
                media: estudo.current.graficoReceitaAnualTotalMedia,
            },
        )

        paletaCoresEspecifica.push(
            COLOR().corChartPadraoVerde
        )

        arrayMax = estudo.current.graficoReceitaAnualTotal



        /*
        if (!arrayNULL(estudo.current.graficoRetiradaReservaAposentadoriaComplementoReceitaMensalTotal)) {

            series.push(
                {
                    name: LABEL.retiradaReservaAposentadoriaComplementoReceitaMensalAnual,
                    type: 'area',
                    data: estudo.current.graficoRetiradaReservaAposentadoriaComplementoReceitaMensalTotal,
                },
            )
            
            paletaCoresEspecifica.push(
                COLOR().corChartPadraoCinzaEscuro
            )

            arrayMax = arraySoma(arrayMax, estudo.current.graficoRetiradaReservaAposentadoriaComplementoReceitaMensalTotal)
        }
        */

        yaxisMax = arrayMaiorValor(arrayMax, yaxisMax)



        series.push(
            {
                name: LABEL.despesaAnual,
                type: 'bar',
                data: estudo.current.graficoDespesaAnualTotal,
                media: estudo.current.graficoDespesaAnualTotalMedia,
            },
        )

        paletaCoresEspecifica.push(
            COLOR().corChartPadraoVermelho
        )

        arrayMax = estudo.current.graficoDespesaAnualTotal



        if (estudo.current.projetoVidaSonhoTracarMeta.length > 0) {

            series.push(
                {
                    name: LABEL.aporteProjetoVidaSonhoAnual,
                    type: 'bar',
                    data: estudo.current.graficoProjetoVidaSonhoAnualTotal,
                },
            )
            
            paletaCoresEspecifica.push(
                COLOR().corChartPadraoProjetoVidaSonho
            )

            arrayMax = arraySoma(arrayMax, estudo.current.graficoProjetoVidaSonhoAnualTotal)
        }


        
        if (!arrayNULL(estudo.current.graficoAporteAnualTotal)) {

            series.push(
                {
                    name: LABEL.aporteAposentadoriaAnual,
                    type: 'bar',
                    data: estudo.current.graficoAporteAnualTotal,
                },
            )
            
            paletaCoresEspecifica.push(
                COLOR().corChartPadraoAporteAposentadoria
            )

            arrayMax = arraySoma(arrayMax, estudo.current.graficoAporteAnualTotal)
        }



        if (!arrayNULL(estudo.current.graficoAporteAtingirMetaInicioAposentadoriaTotal)) {

            series.push(
                {
                    name: LABEL.aporteAtingirMetaInicioAposentadoriaAnual,
                    type: 'bar',
                    data: estudo.current.graficoAporteAtingirMetaInicioAposentadoriaTotal,
                },
            )
            
            paletaCoresEspecifica.push(
                COLOR().corChartPadraoAporteAtingirMetaInicioAposentadoria
            )

            arrayMax = arraySoma(arrayMax, estudo.current.graficoAporteAtingirMetaInicioAposentadoriaTotal)
        }

        

        if (!arrayNULL(estudo.current.graficoAporteAposentadoriaEconomiaReceitaMensalTotal)) {

            series.push(
                {
                    name: LABEL.aporteAposentadoriaEconomiaReceitaMensalAnual,
                    type: 'bar',
                    data: estudo.current.graficoAporteAposentadoriaEconomiaReceitaMensalTotal,
                },
            )
            
            paletaCoresEspecifica.push(
                COLOR().corChartPadraoAporteAposentadoriaBalancoPositivo
            )

            arrayMax = arraySoma(arrayMax, estudo.current.graficoAporteAposentadoriaEconomiaReceitaMensalTotal)
        }



        yaxisMax = arrayMaiorValor(arrayMax, yaxisMax)

        

        series.push(
            {
                name: LABEL.balancoAnual,
                type: 'line',
                data: estudo.current.graficoBalancoAnualTotalComTracarMetaAporte,
            },
        )
        
        paletaCoresEspecifica.push(
            COLOR().corChartPadraoPreto
        )

        yaxisMin = arrayMenorValor(estudo.current.graficoBalancoAnualTotalComTracarMetaAporte, yaxisMin)


        
        yaxisMin = roundEscala(yaxisMin)
        yaxisMax = roundEscala(yaxisMax)



        const categories = estudo.current.graficoIdadesGraficos

        const GridGrafico = report ? GridItem11 : GridItem11


        
        return (
            //<div
            //    {...props}
            //>
                <GridContainer>
                    <GridGrafico>
                        <ChartPadrao
                            titleText={''} // mudança da fonte: titleText={LABEL.balancoReceitaDespesaAnual}
                            type='area'//"bar"
                            tooltipRegularOrder={true}
                            series={series}
                            height={aiFT && report ? 200 : ''}
                            stacked={true}
                            categories={categories}
                            categories2={estudo.current.graficoAnos}
                            paletaCores={paletaCoresEspecifica}
                            dataLabelsEnabled={values.modoApresentacao && values.tabEstudoFormList === LABEL.relatorio}
                            dataLabelsEnabledReport={values.formatoReport === HARDCODE.idFormatoReportImpressao && !aiFT}
                            dataLabelsType='Idade'
                            dataLabelsDestaque={[values.idadeVaiAposentarCliente]}
                            strokeWidth={2}
                            notInverseOrder={true}
                            toolTipX={true}
                            toolTipXTotal={false}
                            report={report}
                            formatoReport={values.formatoReport}
                            modoApresentacao={values.modoApresentacao}
                            fillOpacity={0.65}//0.85
                            //fillType={'gradient'}
                            yaxisTickAmount={4}
                            yaxisMin={yaxisMin}
                            yaxisMax={yaxisMax}
                            mediaMensal={true}
                            dataSimulacaoEstudo={values.dataSimulacaoEstudo}
                            notLegendShow={aiFT}
                            aiFT={aiFT}
                        />
                    </GridGrafico>
                </GridContainer>
            //</div>
        )
    }

    return (
        <GridItem12>
            {report
                ?
                    <BalancoReceitaXDespesaAnual
                        //className='mt--5 ml-5' // mudança da fonte: mt-5
                    />
                :
                    <CardGridEstudoPadrao
                        label={
                            !relatorioModoApresentacao(values)
                                ?
                                    LABEL.balancoReceitaDespesaAnual
                                :
                                    HARDCODE.modoApresentacaoRelatorio
                        }
                        component={
                            <div
                                className='ml-10'
                            >
                                <BalancoReceitaXDespesaAnual/>
                            </div>
                        }
                        overflowX={false}
                        modoApresentacao={values.modoApresentacao}
                        nameListaMoreLess={moreLessList}
                        listaMoreLess={moreLessList ? values[moreLessList] : ''}
                        idListaMoreLess={HARDCODE.balancoReceitaXDespesaAnualChart}
                        setFieldValue={setFieldValue}
                        aiFTOrigem={HARDCODE.analisesInformacoesBalancoReceitaXDespesaAnualChart}
                        variaveisGlobais={variaveisGlobais}
                        values={values}
                        estudo={estudo}
                        vars={vars}
                    />
            }
        </GridItem12>
    )
}

export default BalancoReceitaXDespesaAnualChart